module.exports = __webpack_public_path__ + "headertext-9f2d4d80.png";